import { render } from "./CreatorEconomyArchitecture.vue?vue&type=template&id=1a6abc8c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__